// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Button from "elevate-ui/Button";

const GrayGridButtonList = ({ classes, site }) => {
  const { featuredTowns } = site && site.uiConfig;

  return (
    <div className={classes.root}>
      <Typography type="heading2" gutterBottom>
        Featured Towns
      </Typography>
      <div className={classes.townGrid}>
        {featuredTowns &&
          featuredTowns.map((featuredTown) => {
            return (
              <div key={featuredTown.city} className={classes.buttonContainer}>
                <Button
                  element="a"
                  href={`/listings?city=${featuredTown.city}${
                    featuredTown.state ? `&state=${featuredTown.state}` : ""
                  }`}
                  color="primary"
                  className={classes.button}
                >
                  {featuredTown.city}, {featuredTown.state}
                </Button>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: "56px 0",
    textAlign: "center",
  },
  townGrid: {
    display: "flex",
    position: "relative",
    flexFlow: "row wrap",
    justifyContent: "space-around",
    alignItems: "center",
    width: "100%",
    maxWidth: "1024px",
    margin: "12px auto",
  },
  buttonContainer: {
    flex: "0 1 100%",
    padding: theme.spacing.unit * 0.5,
    [theme.breakpoints(768)]: {
      flex: "0 1 33.3333%",
    },
  },
  button: {
    width: "100%",
  },
});

export default withGlobalContext(withStyles(styles)(GrayGridButtonList));
